var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 30h13c5.085 0 8.5-3.567 8.5-8.875V8.875C30 3.567 26.585 0 21.5 0h-13C3.414 0 0 3.567 0 8.875v12.25C0 26.433 3.415 30 8.5 30zm1.248-16.5A3.753 3.753 0 016 9.75C6 7.683 7.68 6 9.748 6a3.754 3.754 0 013.749 3.75 3.754 3.754 0 01-3.749 3.75zm16.983 5.9c.502 1.289.242 2.837-.295 4.112-.637 1.517-1.856 2.666-3.391 3.168a6.788 6.788 0 01-2.11.32H8.293c-1.258 0-2.371-.302-3.284-.864-.571-.353-.672-1.167-.249-1.695.71-.882 1.41-1.768 2.115-2.66 1.346-1.71 2.252-2.205 3.26-1.77.408.18.819.449 1.241.734 1.125.764 2.69 1.815 4.75.674 1.41-.79 2.228-2.144 2.94-3.323l.012-.02.15-.248c.24-.396.476-.787.743-1.147.335-.45 1.576-1.859 3.184-.856 1.024.632 1.885 1.486 2.807 2.401.351.35.602.748.77 1.175z",
    fill: "#fff"
  })));
}

export default SvgPicture;